import {AxiosRequestConfig} from 'axios';
import {useInfiniteQuery} from 'react-query';
import request from '../../axios';
import {IBrandListResponse} from './types';

interface IGetBrandListPayload {
  pageSize?: number;
  search?: string;
  input_guid?: string;
  sub_input_guid?: string;
}

const useGetListBrand = (payload?: IGetBrandListPayload) => {
  const {
    data: rawData,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
  } = useInfiniteQuery(
    ['list-brand', payload],
    ({pageParam = 1}) => fetcher(pageParam, payload),
    {
      getNextPageParam: lastPage => {
        const nextPageUrl = lastPage?.next;
        if (!nextPageUrl) return undefined;

        const nextPage = new URL(nextPageUrl).searchParams.get('page');
        return nextPage ? Number(nextPage) : undefined;
      },
    },
  );

  const data = rawData?.pages.flatMap(page => page.results);

  return {
    data,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
  };
};

export default useGetListBrand;

// ------------------------------------------------------------------
//* Exclusive fetcher function to this infinite query
// ------------------------------------------------------------------

const fetcher = async (
  pageParam: number,
  payload?: IGetBrandListPayload,
): Promise<IBrandListResponse> => {
  const {data} = await request.get(`api/v2/warehouse/brand`, {
    params: {
      page: pageParam,
      page_size: payload?.pageSize ?? 10,
      ...(payload?.search && {search: payload?.search}),
      ...(payload?.input_guid && {input_guid: payload?.input_guid}),
      ...(payload?.sub_input_guid && {sub_input_guid: payload?.sub_input_guid}),
    },
  } as AxiosRequestConfig);

  return data as IBrandListResponse;
};
